/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-05-10 14:57:46
 * @LastEditors: linxi
 * @LastEditTime: 2021-07-06 10:36:54
 */
import { Button, Col, Form, Input, Row, Select, Space } from "antd";
import React from "react";
import { SearchOutlined } from "@ant-design/icons";
import {
  BillingCategories,
  BillingCategoryName,
  InvoiceBillingCategories,
} from "../../../models/billingCategory";
import { useDispatch } from "react-redux";
import { supplierParams } from "../../../services/supplier";
import { setModalCurrent } from "./InventStockModalSlice";
import {
  getMaterialsCategoryName,
  MaterialsCategories,
} from "../../../models/commodity";
const { Option } = Select;

export const InventModalQuery = (props: {
  onValueChange: (queries: supplierParams) => void;
}) => {
  const [form] = Form.useForm();

  const dispatch = useDispatch();
  return (
    <Form
      form={form}
      name="control-hooks"
      onFieldsChange={(_, fs) => {
        dispatch(setModalCurrent(1));
        props.onValueChange(form.getFieldsValue());
      }}
    >
        <Row
          style={{
            margin: '10px 0',
          }}
          justify='space-between'
        >
          <Space>
          <Form.Item name="name" noStyle style={{width:'12rem'}}>
            <Input
              placeholder="请输入药品名称进行检索"
              allowClear
              prefix={<SearchOutlined />}
            />
          </Form.Item>
          <Form.Item name="billingCategory" noStyle>
            <Select placeholder="开票项目" allowClear style={{width:'8rem'}}>
              {InvoiceBillingCategories.map((v) => {
                return (
                  <Option value={v} key={v}>
                    {BillingCategoryName(v)}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
          <Form.Item name="materialsCategory" noStyle>
            <Select
              allowClear
              style={{width:'8rem'}}
              placeholder="物资类别"
              // mode="multiple"
            >
              {MaterialsCategories.map((v) => (
                <Option value={v} key={v}>
                  {getMaterialsCategoryName(v)}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name="showFlag" noStyle>
            <Select
              allowClear
              placeholder="是否显示零库存"
              style={{width:'10rem'}}
              // mode="multiple"
            >
              <Option value={0} key={0}>否</Option>
              <Option value={1} key={1}>是</Option>
            </Select>
          </Form.Item>
          <Button htmlType="submit" type="primary">
            查询
          </Button>
        </Space>
      </Row>
    </Form>
  );
};
